import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import FallSpeedBonusSkillNode from "./FallSpeedBonusSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";

export default class FallSpeedBonusSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     */
    constructor(totals, values) {
        super(SkillIds.FALL_BONUS);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 15;
        let cost = 75;

        const fallBonus1 = this.addNode(new FallSpeedBonusSkillNode('fallBonus1', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus2 = this.addNode(new FallSpeedBonusSkillNode('fallBonus2', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus3 = this.addNode(new FallSpeedBonusSkillNode('fallBonus3', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus4 = this.addNode(new FallSpeedBonusSkillNode('fallBonus4', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus5 = this.addNode(new FallSpeedBonusSkillNode('fallBonus5', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus6 = this.addNode(new FallSpeedBonusSkillNode('fallBonus6', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus7 = this.addNode(new FallSpeedBonusSkillNode('fallBonus7', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus8 = this.addNode(new FallSpeedBonusSkillNode('fallBonus8', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus9 = this.addNode(new FallSpeedBonusSkillNode('fallBonus9', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus10 = this.addNode(new FallSpeedBonusSkillNode('fallBonus10', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus11 = this.addNode(new FallSpeedBonusSkillNode('fallBonus11', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus12 = this.addNode(new FallSpeedBonusSkillNode('fallBonus12', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));


        cost += inc;

        const fallBonus13 = this.addNode(new FallSpeedBonusSkillNode('fallBonus13', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus14 = this.addNode(new FallSpeedBonusSkillNode('fallBonus14', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus15 = this.addNode(new FallSpeedBonusSkillNode('fallBonus15', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus16 = this.addNode(new FallSpeedBonusSkillNode('fallBonus16', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus17 = this.addNode(new FallSpeedBonusSkillNode('fallBonus17', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus18 = this.addNode(new FallSpeedBonusSkillNode('fallBonus18', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus19 = this.addNode(new FallSpeedBonusSkillNode('fallBonus19', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus20 = this.addNode(new FallSpeedBonusSkillNode('fallBonus20', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const fallBonus21 = this.addNode(new FallSpeedBonusSkillNode('fallBonus21', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));
        


        fallBonus1.addChildNode(fallBonus2);
        fallBonus2.addChildNode(fallBonus3);
        fallBonus3.addChildNode(fallBonus4);
        fallBonus4.addChildNode(fallBonus5);
        fallBonus5.addChildNode(fallBonus6);
        fallBonus6.addChildNode(fallBonus7);
        fallBonus7.addChildNode(fallBonus8);

        fallBonus8.addChildNode(fallBonus9);
        fallBonus9.addChildNode(fallBonus10);
        fallBonus10.addChildNode(fallBonus11);
        fallBonus11.addChildNode(fallBonus12);
        fallBonus12.addChildNode(fallBonus13);
        fallBonus13.addChildNode(fallBonus14);
        fallBonus14.addChildNode(fallBonus15);

        fallBonus15.addChildNode(fallBonus16);
        fallBonus16.addChildNode(fallBonus17);
        fallBonus17.addChildNode(fallBonus18);
        fallBonus18.addChildNode(fallBonus19);
        fallBonus19.addChildNode(fallBonus20);
        fallBonus20.addChildNode(fallBonus21);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = 4;
        const startY = -15;

        fallBonus1.setPosition(startX, startY);
        fallBonus2.setPosition(startX + 1, startY);
        fallBonus3.setPosition(startX + 2, startY);
        fallBonus4.setPosition(startX + 3, startY);
        fallBonus5.setPosition(startX + 4, startY);
        fallBonus6.setPosition(startX + 5, startY);
        fallBonus7.setPosition(startX + 6, startY);

        fallBonus8.setPosition(startX + 6, startY - 1);
        fallBonus9.setPosition(startX + 5, startY - 1);
        fallBonus10.setPosition(startX + 4, startY - 1);
        fallBonus11.setPosition(startX + 3, startY - 1);
        fallBonus12.setPosition(startX + 2, startY - 1);
        fallBonus13.setPosition(startX + 1, startY - 1);
        fallBonus14.setPosition(startX, startY - 1);

        fallBonus15.setPosition(startX, startY - 2);
        fallBonus16.setPosition(startX + 1, startY - 2);
        fallBonus17.setPosition(startX + 2, startY - 2);
        fallBonus18.setPosition(startX + 3, startY - 2);
        fallBonus19.setPosition(startX + 4, startY - 2);
        fallBonus20.setPosition(startX + 5, startY - 2);
        fallBonus21.setPosition(startX + 6, startY - 2);

    }
    
}